import { Route, Routes } from 'react-router-dom';

import TasksPage from './tasks-page';

export default function TasksRouter() {
    return (
        <Routes>
            <Route
                path="/"
                element={<TasksPage />}
            />
        </Routes>
    );
}